import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import swal from "sweetalert";
import {
  CREATE_USER,
  UPDATE_USER,
  ACTIVATE_USER,
  DEACTIVATE_USER,
} from "../../data/userData";
import {
  fetchDataEngine,
  generateAndExecuteMutationException,
  graphqlQuery,
} from "../../data/Axios/DynamicService";
import {
  allCompanies,
  allRegions,
  getrolesquery,
  allUsersQuery,
  allGenders,
} from "../../data/Axios/queries";
import {
  companyManagementUrl,
  loanManagementUrl,
  roleManagemenUrl,
  setupManagementUrl,
  userManagementUrl,
} from "../../config";
import DynamicForm from "../../data/Axios/DynamicForm";
import { usersField } from "../../data/DynamicTable/usersDynamicForms";
import Swal from "sweetalert2";
import {
  executeAnyMutation,
  fetchJson,
  fetchJsonDynamic,
} from "../../data/DynamicServiceNew/jsondynamicservice";

const base_url = roleManagemenUrl.uri;
const setup_url = companyManagementUrl.uri;
const UsersForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const tokenRegionId = parseInt(decodedToken.RegionId);
  const tokenBranchId = parseInt(decodedToken.BranchId);
  const [roleData, setRoleData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [companyData, setCompanyData] = useState([]);
  const [showRegions, setShowRegions] = useState(false);
  const [showBranches, setShowBranches] = useState(false);
  const [genderData, setGenderData] = useState([]);
  const [branchoptionsInitialvalue, setBranchOptionsInitialValue] = useState(
    []
  );
  const [branchIdData, setBranchIdData] = useState(null);
  const [regionIdData, setRegionIdData] = useState(null);
  const [showRegionsOnly, setShowRegionsOnly] = useState(false);
  const [selectedRegionId, setSelectedRegionId] = useState([]);
  const [Mappedbranches, setMappedBranches] = useState([]);
  const [isOfficerRole, setIsOfficerRole] = useState(false);
  const [isCollectionOfficer, setIsCollectionOfficer] = useState(false);
  const [hasCoFoMapSetting, setHasCoFoMapSetting] = useState(false);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [MappedFOs, setMappedFOs] = useState([]);
  const [existingMapping, setExistingMapping] = useState(null);
  const [formKey, setFormKey] = useState(0);
  const [isSuperAdminRole, setIsSuperAdminRole] = useState(false);
  const initialValues = {
    firstName: props.userData ? props.userData.FirstName : "",
    lastName: props.userData ? props.userData.LastName : "",
    email: props.userData ? props.userData.Email : "",
    phone: props.userData ? props.userData.Phone : "",
    username: props.userData ? props.userData.Username : "",
    idno: props.userData ? props.userData.Idno : "",
    roleId: props.userData ? props.userData.RoleId : "",
    roleName: props.userData ? props.userData.RoleName : "",

    genderId: props.userData ? props.userData.GenderId : "",
    regionId: props.userData ? props.userData.RegionId : "",
    branchId: props.userData ? props.userData.BranchId : "",
    isCollectionOfficer: props.userData ? !!props.userData.IsCollectionOfficer : false,
    fieldOfficerId: existingMapping ? existingMapping.fieldOfficerId : "",
    canAccessCallcenter: props.userData ? !!props.userData.CanAccessCallcenter : false,
    canApproveWithdrawals: props.userData ? !!props.userData.CanApproveWithdrawals : false,
    canApproveOverdraft: props.userData ? !!props.userData.CanApproveOverdraft : false,
  };

  useEffect(() => {
    async function fetchAllData() {
      try {
        const facts = await graphqlQuery(getrolesquery, base_url);
        if (facts) {
          setRoleData(facts);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchAllData();
  }, []);

  // When editing an existing user, re-apply handleRoleChange once roleData
  // has loaded so that all conditional UI flags (isSuperAdminRole, isOfficerRole,
  // showRegions, etc.) are correctly initialised from the saved RoleId.
  useEffect(() => {
    if (props.isEditing && props.userData?.RoleId && roleData.length > 0) {
      handleRoleChange(props.userData.RoleId);
    }
  }, [roleData, props.userData]);

  // The Collection Officer <-> Field Officer mapping feature is gated per
  // company by the "Has C0-FO Map" loan setting — companies without it
  // shouldn't see the checkbox or trigger any of the mapping fetches.
  useEffect(() => {
    async function fetchLoanSettings() {
      try {
        const response = await fetchJsonDynamic(
          "loanSettings",
          null,
          null,
          loanManagementUrl.uri
        );
        if (response?.results) {
          const settings = JSON.parse(response.results);
          const coFoMapSetting = settings.find(
            (s) => s.Setting === "Has C0-FO Map"
          );
          setHasCoFoMapSetting(coFoMapSetting?.Value?.toLowerCase() === "true");
        }
      } catch (error) {
        console.error("Error fetching loan settings:", error);
        setHasCoFoMapSetting(false);
      }
    }
    fetchLoanSettings();
  }, []);

  useEffect(() => {
    async function fetchAllData() {
      try {
        const regionResponse = await fetchJson({
          objectName: "region",

          baseUrl: companyManagementUrl.uri,
        });
        const allRegions = JSON.parse(regionResponse.results) || [];

        if (allRegions) {
          setRegionData(allRegions || []);
        }

        // Fetch branch data if userData has regionId
        if (tokenRegionId) {
          const branchResponse = await fetchBranches(tokenRegionId);
          setBranchData(branchResponse || []);
        }

        // Determine visibility of regions and branches
        if (props.userData && props.userData.roleId) {
          handleRoleChange(props.userData.roleId);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchAllData();
  }, [props.userData]);

  // If editing an existing Collection Officer (and the company has the
  // CO-FO map feature enabled), load their current mapping so the checkbox
  // and dropdown pre-populate correctly.
  useEffect(() => {
    if (!props.isEditing || !props.userData?.IsCollectionOfficer || !hasCoFoMapSetting) {
      return;
    }
    async function loadExistingMapping() {
      try {
        setIsOfficerRole(true);
        setIsCollectionOfficer(true);
        const mapResponse = await fetchJsonDynamic(
          "fieldOfficerCollectionOfficerMap",
          "filter",
          { collectionOfficerId: props.userData.Id },
          userManagementUrl.uri
        );
        const mapping = JSON.parse(mapResponse?.results || "null");
        if (mapping) {
          setExistingMapping({ id: mapping.Id, fieldOfficerId: mapping.FieldOfficerId });
          setSelectedBranchId(props.userData.BranchId);
          await fetchAvailableFieldOfficers(props.userData.BranchId, mapping.Id);
          setFormKey((key) => key + 1);
        }
      } catch (error) {
        console.error("Error fetching existing collection officer mapping:", error);
      }
    }
    loadExistingMapping();
  }, [props.userData, hasCoFoMapSetting]);

  const handleFieldChange = async (field, value) => {
    if (field.name === "roleId") {
      handleRoleChange(value);
      setSelectedRegionId(value);
    }
    if (field.name === "regionId") {
      console.log("Selected Region ID:", value); // Log the selected region ID
      const branchOptions = await fetchBranches(value);
      console.log("Fetched Branch Options:", branchOptions); // Log the fetched options
      setBranchOptionsInitialValue(branchOptions || []); // Ensure an array is set
      setBranchData(branchOptions); // Set the branch data for further rendering in form
      console.log("Branch Options:", branchOptions); // Log branch options
      setBranchIdData(null); // Reset the branchId data if region changes
      return branchOptions;
    }
    if (field.name === "branchId") {
      setSelectedBranchId(value);
      if (hasCoFoMapSetting && isCollectionOfficer) {
        await fetchAvailableFieldOfficers(value);
      }
    }
    if (field.name === "isCollectionOfficer") {
      setIsCollectionOfficer(value);
      if (hasCoFoMapSetting && value) {
        await fetchAvailableFieldOfficers(selectedBranchId || branchIdData);
      } else {
        setMappedFOs([]);
      }
    }
  };

  const fetchAvailableFieldOfficers = async (
    branchId,
    excludeMappingId = existingMapping?.id
  ) => {
    const parsedBranchId = parseInt(branchId, 10);
    if (!parsedBranchId || Number.isNaN(parsedBranchId)) {
      setMappedFOs([]);
      return [];
    }
    try {
      const response = await fetchJsonDynamic(
        "availableFieldOfficers",
        "filter",
        {
          branchId: parsedBranchId,
          excludeMappingId: excludeMappingId || null,
        },
        userManagementUrl.uri
      );
      const officers = JSON.parse(response?.results) || [];
      const FOOptions = officers.map((officer) => ({
        parent_key: officer.Id,
        value: officer.Id,
        label: `${officer.FirstName} ${officer.LastName}`,
      }));
      setMappedFOs(FOOptions);
      return FOOptions;
    } catch (error) {
      console.error("Error fetching available field officers:", error);
      setMappedFOs([]);
      return [];
    }
  };

  const fetchBranches = async (regionId) => {
    try {
      console.log("Fetching branches for regionId:", regionId);
      const params = { regionId: parseInt(regionId) };
      console.log("Params for API call:", params);

      const businessDetails = await fetchJsonDynamic(
        "allBranchesByColumnValues",
        "branchModel",
        params,
        setup_url
      );

      console.log("API Response:", businessDetails);

      const allBranchDetails = JSON.parse(businessDetails.results) || [];
      console.log("Parsed branch details:", allBranchDetails);

      const branchOptions = allBranchDetails.map((role) => ({
        parent_key: role.Id,
        value: role.Id,
        label: role.Name,
      }));

      console.log("Mapped Branch Options:", branchOptions);
      setMappedBranches(branchOptions);

      return branchOptions; // Return the mapped branch options
    } catch (error) {
      console.error("Error fetching branches:", error);
      return [];
    }
  };

  const handleRoleChange = (roleId) => {
    const selectedRole = roleData.find((role) => role.id === parseInt(roleId));
    if (selectedRole) {
      const { roleGroupId } = selectedRole;
      setIsOfficerRole(roleGroupId === 5);
      // Show withdrawal/overdraft approver checkboxes for Super Admin role groups
      setIsSuperAdminRole(roleGroupId === 1 || roleGroupId === 2);
      if (roleGroupId !== 5) {
        setIsCollectionOfficer(false);
        setMappedFOs([]);
      }
      const tokenRoleGroupId = parseInt(decodedToken.RoleGroupId);
      if (tokenRoleGroupId === 1 || tokenRoleGroupId === 2) {
        if (roleGroupId === 1 || roleGroupId === 2) {
          setShowRegions(false);
          setShowBranches(false);
          setShowRegionsOnly(false);
        } else if (roleGroupId === 3) {
          setShowRegionsOnly(true);
          setShowRegions(false);
          setShowBranches(false);
        } else if (roleGroupId === 4 || roleGroupId === 5) {
          setShowRegions(true);
          setShowBranches(false);
          setShowRegionsOnly(false);
        }
      } else if (tokenRoleGroupId === 3) {
        if (roleGroupId === 3) {
          setShowRegionsOnly(false);
          setShowRegions(false);
          setShowBranches(false);
          setRegionIdData(tokenRegionId);
        } else if (roleGroupId === 4 || roleGroupId === 5) {
          setShowRegions(false);
          setShowBranches(true);
          setShowRegionsOnly(false);
          setRegionIdData(tokenRegionId);
        }
      } else {
        if (roleGroupId === 4 || roleGroupId === 5) {
          setShowRegions(false);
          setShowBranches(false);
          setShowRegionsOnly(false);
          setBranchIdData(tokenBranchId);

          setRegionIdData(tokenRegionId);
        }
      }
    }
  };

  const roleOptions = roleData
    ? roleData.map((role) => ({
        parent_key: role.id,
        value: role.id,
        label: role.role,
      }))
    : [];
  const regionOptions = regionData
    ? regionData.map((role) => ({
        parent_key: role.Id,
        value: role.Id,
        label: role.Name,
      }))
    : [];


  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        firstName,
        lastName,
        email,
        phone,
        username,
        idno,
        roleId,
        gender,
        regionId,
        branchId,
      } = values;
       // Find the selected role to get its roleGroupId
    const selectedRole = roleData.find(role => role.id === parseInt(roleId));
    const roleGroupId = selectedRole?.roleGroupId || null;

      const stringedphone = phone.toString();
      const stringedidno = idno.toString();
      const mutationData = {
        firstName,
        lastName,
        email,
        phone: stringedphone,
        username,
        idno: stringedidno,
        branchId: branchId || branchIdData || null,
        regionId: regionId || regionIdData || null,
        roleId: parseInt(roleId),
        roleGroupId: roleGroupId,
        createdBy: userId,
        canAccessCallcenter: values.canAccessCallcenter ? 1 : 0,
        // Only include approver flags when the role is a Super Admin / Admin group
        // (roleGroupId 1 or 2) — avoids sending unknown fields for other role types
        ...(isSuperAdminRole && {
          canApproveWithdrawals: values.canApproveWithdrawals ? 1 : 0,
          canApproveOverdraft: values.canApproveOverdraft ? 1 : 0,
        }),
      };

      if (props.isEditing) {
        mutationData.id = props.userData.Id;
        // Preserve the current lock status so UpdateDynamically doesn't overwrite
        // it with null — which would lock/reset the account unintentionally.
        mutationData.isAccountLocked = props.userData.IsAccountLocked ?? 0;
      }

      const response = await executeAnyMutation(
        props.isEditing ? "updateUser" : "createUser",
        mutationData,
        "user",
        false,
        userManagementUrl.uri
      );

      if (response.results) {
        let mappingErrorMessage = null;

        if (isCollectionOfficer && values.fieldOfficerId) {
          const collectionOfficerId = props.isEditing
            ? props.userData.Id
            : JSON.parse(response.results)?.Id;

          const mapResponse = await executeAnyMutation(
            existingMapping?.id
              ? "updateFieldOfficerCollectionOfficerMap"
              : "createFieldOfficerCollectionOfficerMap",
            {
              id: existingMapping?.id || null,
              fieldOfficerId: parseInt(values.fieldOfficerId),
              collectionOfficerId,
              createdBy: userId,
            },
            "map",
            false,
            userManagementUrl.uri
          );

          if (mapResponse?.error) {
            const mapErrorObj = JSON.parse(mapResponse.error);
            mappingErrorMessage =
              mapErrorObj?.Error?.match(/System\.Exception: (.*?)\./)?.[1] ||
              "Failed to save the field officer mapping.";
          }
        }

        props.onClose();
        props.refetch();

        if (mappingErrorMessage) {
          Swal.fire({
            icon: "warning",
            title: `User ${props.isEditing ? "updated" : "created"}, but...`,
            text: mappingErrorMessage,
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `User ${props.isEditing ? "updated" : "created"} successfully.`,
          });
        }
      } else if (response.error) {
        const errorObj = JSON.parse(response.error);
        const errorMessage = errorObj?.Error?.match(
          /System\.Exception: (.*?)\./
        )?.[1]; // Extract the error message
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: errorMessage,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  const fields = [
    ...usersField,

    {
      name: "roleId",
      label: "Role *",
      type: "select",
      options: roleData
        ? roleData.map((role) => ({
            value: role.id,
            label: role.role,
          }))
        : [],
      gridColumn: "span 2",
      required: true,
      parent: "main",
    },
    ...(showRegionsOnly
      ? [
          {
            name: "regionId",
            label: "Region *",
            type: "select",
            options: regionData
              ? regionData.map((region) => ({
                  value: region.Id,
                  label: region.Name,
                }))
              : [],
            gridColumn: "span 2",
            //parent: "main",
          },
        ]
      : []),
    ...(showRegions
      ? [
          {
            name: "regionId",
            label: "Region *",
            type: "select",
            options: regionData
              ? regionData.map((region) => ({
                  value: region.Id,
                  label: region.Name,
                }))
              : [],
            gridColumn: "span 2",
            parent: "main",
          },
          {
            name: "branchId",
            label: "Branch *",
            type: "select",
            options: Mappedbranches,
            gridColumn: "span 2",
            required: true,
            parent: "dependent",
            dependentOn: "regionId",
          },
        ]
      : []),
    ...(showBranches
      ? [
          {
            name: "branchId",
            label: "Branch *",
            type: "select",
            options: Mappedbranches,
            gridColumn: "span 2",
            required: true,
            // parent: "dependent",
            // dependentOn: "regionId",
          },
        ]
      : []),
    ...(isOfficerRole && hasCoFoMapSetting
      ? [
          {
            name: "isCollectionOfficer",
            label: "Is Collection Officer?",
            type: "checkbox",
            gridColumn: "span 2",
          },
        ]
      : []),
    ...(isOfficerRole && hasCoFoMapSetting && isCollectionOfficer
      ? [
          {
            name: "fieldOfficerId",
            label: "Field Officer *",
            type: "select",
            options: MappedFOs,
            gridColumn: "span 2",
            required: true,
          },
        ]
      : []),
      {
        name: "canAccessCallcenter",
        label: "Can Access Call Center?",
        type: "checkbox",
        gridColumn: "span 2",
      },
    ...(isSuperAdminRole
      ? [
          {
            name: "canApproveWithdrawals",
            label: "Withdrawal Approver?",
            type: "checkbox",
            gridColumn: "span 2",
          },
          {
            name: "canApproveOverdraft",
            label: "Overdraft Facility Approver?",
            type: "checkbox",
            gridColumn: "span 2",
          },
        ]
      : []),
  ];

  return (
    <div>
      <DynamicForm
        key={formKey}
        initialValues={initialValues}
        fields={fields}
        onFieldChange={handleFieldChange}
        onSubmit={handleSubmit}
        title={props.isEditing ? "Edit User" : "Create User"}
        subtitle={
          props.isEditing ? "Edit an Existing User" : "Create a New User"
        }
      />
    </div>
  );
};

export default UsersForm;